export default __webpack_public_path__ + "static/media/Breeches of the Crawling Chaos.ed05acc2.jpg";